import { Component, OnInit, ElementRef, Inject, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { LanguageService } from '../../services/language.service';

import { MatDialog, MatDialogRef, MatDialogConfig, MAT_DIALOG_DATA } from '@angular/material/dialog';

import { ManageAvaluaService } from '../../manage-project/project-data/manage-avalua.service';
import { IAvalua } from './avaluar.interfaces';

@Component({
  selector: 'dialog-avaluar',
  templateUrl: 'dialog.component.avaluar.html',
  styleUrls: ['dialog.component.avaluar.css'],
  providers: [ManageAvaluaService]
})

export class DialogAvaluar {
  public documentAvalua: IAvalua = {
  'codi': '', 'avaluacio': '','competidors': '', 'revisio': '', 'enfocament': '', 'perfils': '', 'reunions_socis': '',
  'acord_socis': '', 'aportacions_socis': '', 'estrucura_tecnica': '', 'golden_tecnica': '',
  'adaptacio_cv_perfils': '', 'adaptacio_cv_empresa': '', 'fitxes_tecnica': '', 'metodologia_tecnica': '',
  'pla_tecnica': '', 'responsabilitat_tecnica': '', 'organigrama_tecnica': '', 'cronograma_tecnica': '',
  'pressupost_tecnica': '', 'revisio_lliurament': '', 'control_lliurament': '', 'client_lliurament': '', 
  'soci_lliurament': '', 'arxiu_sg': '', 'arxiu_servidor':  '',
  };

  public editAvaluaData = Object.assign(this.documentAvalua);
  public opcions = [
  { nom: '', valor: '1', color: 'white' },
  { nom: '', valor: '2', color: 'red' },
  { nom: '', valor: '3', color: 'orange' },
  { nom: '', valor: '4', color: 'yellow' },
  { nom: '', valor: '5', color: 'green' }
  ];
  
  constructor(
    public translate: TranslateService, public languageService: LanguageService, protected manageAvaluaService: ManageAvaluaService, public dialogRef: MatDialogRef<DialogAvaluar>, @Inject(MAT_DIALOG_DATA) public data: any){
    this.manageAvaluaService.get(data).subscribe(dades => { this.editAvaluaData = dades[0]; });
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  desar(): void {
    this.dialogRef.close(this.editAvaluaData);
  }

  ngOnInit(){ }

 /* public getColorPerValor(valor: string): string {
    const valorNum = Number(valor);
    const opcio = this.opcions.find(o => o.valor === valorNum);
    return opcio ? opcio.color : 'transparent';
  }

  public getNomPerValor(valor: string): string {
    const valorNum = Number(valor);
    const opcio = this.opcions.find(o => o.valor === valorNum);
    return opcio ? opcio.nom : '';
  }
*/

getNomPerValor(valor: string): string {
  const trobat = this.opcions.find(o => o.valor === valor);
  return trobat ? trobat.nom : '';
}

getColorPerValor(valor: string): string {
  const trobat = this.opcions.find(o => o.valor === valor);
  return trobat ? trobat.color : 'transparent';
}

}